import { inject, Pipe, PipeTransform } from '@angular/core';
import { DateFormatShorthand, LocaleFormatService } from 'src/core/services';
import { LanguageStore } from 'src/core/stores';

@Pipe({
  name: 'localeDate',
  standalone: true,
  pure: false,
})
export class LocaleDatePipe implements PipeTransform {
  private readonly localeFormatService = inject(LocaleFormatService);
  private readonly languageStore = inject(LanguageStore);

  transform(
    value: Date | string | number | null | undefined,
    format: DateFormatShorthand | Intl.DateTimeFormatOptions = 'mediumDate',
  ): string {
    void this.languageStore.locale();
    return this.localeFormatService.formatDate(value, format);
  }
}
